module.exports = __webpack_public_path__ + "static/media/no-change.69406d3e.svg";